<template>
<div class="dashboard-section">
    <div class="ds-header">
        <md-icon>{{ icon }}</md-icon>
        <span class="ds-title">{{ title }}</span>
    </div>

    <dashboard-project-grid
        v-if="viewMode === 'grid'"
        :projects="projects"
        @projectAccepted="$emit('projectAccepted', $event)"
        @projectDeleted="$emit('projectDeleted', $event)"
    />
    <dashboard-list
        v-else
        :projects="projects"
        :sort="sort"
        @sortChange="$emit('sortChange', $event)"
        @projectAccepted="$emit('projectAccepted', $event)"
        @projectDeleted="$emit('projectDeleted', $event)"
    />

    <div class="ds-more" v-if="showViewMore">
        <a href="#" class="ds-view-more" @click.prevent="$emit('viewMore')" v-if="!loadingMore">View more</a>
        <span class="ds-loading" v-else>Loading…</span>
    </div>
</div>
</template>

<script>
/**
 * One dashboard section (Pinned or Recent): a labelled header + the section's
 * projects rendered in the current view mode. The parent passes an
 * already-filtered, already-sorted list; sort is shared across sections.
 */
import DashboardProjectGrid from '@/components/dashboard/project-grid';
import DashboardList from '@/components/dashboard/dashboard-list';

const DashboardSection = {
    name: 'DashboardSection',
    props: {
        title: { type: String, required: true },
        icon: { type: String, default: 'folder' },
        projects: { type: Array, default: () => [] },
        viewMode: { type: String, default: 'grid' },
        sort: { type: Object, default: () => ({ key: 'date', dir: 'desc' }) },
        showViewMore: { type: Boolean, default: false },
        loadingMore: { type: Boolean, default: false }
    },
    components: {
        'dashboard-project-grid': DashboardProjectGrid,
        'dashboard-list': DashboardList
    }
};
export default DashboardSection;
</script>

<style lang="scss">
.dashboard-section {
    margin-bottom: 24px;
    .ds-header {
        display: flex;
        align-items: center;
        gap: 2px;
        padding-bottom: 6px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        margin-bottom: 12px;
        i {
            color: var(--accent);
            font-size: 20px !important;
            width: auto;
            min-width: 0;
            margin: 0;
        }
        .ds-title { font-size: 18px; font-weight: 600; color: #333; }
    }
    .ds-more {
        margin-top: 12px;
        // The hover colour is stated explicitly. main.js registers only
        // `primary` on the vue-material theme, so `accent` is still
        // vue-material's factory default (pink) and `warn` its default
        // (deep-orange). Those are injected at runtime — they never appear in
        // the built stylesheet — and the pink was bleeding onto this link on
        // hover, a colour that exists nowhere in the Cuelist palette.
        .ds-view-more {
            color: #2a9fb3;
            font-weight: 600;
            text-decoration: none;
            &:hover, &:focus, &:active {
                color: #1d7f90;
                text-decoration: underline;
            }
        }
        .ds-loading { color: #888; }
    }
}
.md-theme-show-mode {
    .dashboard-section {
        .ds-header { border-bottom-color: rgba(255,255,255,0.2); .ds-title { color: rgba(255,255,255,0.9); } }
    }
}
</style>


// WEBPACK FOOTER //
// dashboard-section.vue?17dff735